<div class="wrapper"
     [class.not-applicable]="status === InComplianceStatus.NOT_APPLICABLE"
     [class.in-compliance]="status === InComplianceStatus.IN_COMPLIANCE"
     [class.out-of-compliance]="status === InComplianceStatus.OUT_OF_COMPLIANCE"
     [class.missing]="status === InComplianceStatus.MISSING">
    <span></span>
</div>
